import { AppState } from 'src/app/store/reducers/app.state';
import * as fromRoot from 'src/app/store';

export interface State extends fromRoot.State.State {
    appstate: AppState;
    classificationsearchstate: ClassificationSearchState;
  }

export interface ClassificationSearchState {
    classification: any;
    classifications: any;
}

export const initialState: ClassificationSearchState = {
    classification: {},
    classifications: {}
};